module.exports = __webpack_public_path__ + "static/media/prod1.278b253b.png";